import { BAOCustomElement } from '@bao/custom-element'
import { Cart } from '@bao/cart'
import { eventBus, EVENTS } from '@bao/events'
import { sectionRenderer } from '@bao/section-rendering'

class CartRemovedItem extends BAOCustomElement() {
  constructor () {
    super()

    this._loading = false
    this.sections = this.inPushCart
      ? sectionRenderer.pushCartSections
      : this.onCartPage
        ? sectionRenderer.cartSections
        : []
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els.remove?.exists) return

    this.els.remove.elements.forEach((removeEl) => {
      this.listeners.add(removeEl, 'click', this.clearCartAttribute.bind(this))
    })

    this.handleDrawerChange = this.handleDrawerChange.bind(this)
    document.addEventListener('drawer-changed', this.handleDrawerChange)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    document.removeEventListener('drawer-changed', this.handleDrawerChange)
  }

  async clearCartAttribute (e) {
    e?.preventDefault()

    const attributes = {
      removed_line_item: null,
    }

    eventBus.dispatchEvent(EVENTS.PUSH_CART.BEFORE_CLEAR_CART_ATTRIBUTES, {
      attributes,
    })

    const state = await Cart.updateCartAttributes(attributes, {
      sections: this.mappedSections,
    })

    eventBus.dispatchEvent(EVENTS.PUSH_CART.AFTER_CLEAR_CART_ATTRIBUTES, {
      state,
    })
  }

  handleDrawerChange () {
    this.clearCartAttribute()
  }

  get pushCart () {
    return this.closest('push-cart')
  }

  get inPushCart () {
    return this.pushCart != null
  }

  get cart () {
    return this.closest('cart-page')
  }

  get onCartPage () {
    return this.cart != null
  }

  get mappedSections () {
    return this.sections.map((s) => s.section)
  }
}

if (!customElements.get('cart-removed-item')) {
  customElements.define('cart-removed-item', CartRemovedItem)
}
